import { render, staticRenderFns } from "./ShowMore.vue?vue&type=template&id=67466df0&scoped=true"
import script from "./ShowMore.vue?vue&type=script&lang=js"
export * from "./ShowMore.vue?vue&type=script&lang=js"
import style0 from "./ShowMore.vue?vue&type=style&index=0&id=67466df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67466df0",
  null
  
)

export default component.exports